import { apiClient } from './api/client';

export type VelosterHealthLevel =
  | 'operational'
  | 'degraded'
  | 'outage'
  | 'scheduled_off'
  | 'unknown';

/** Espelha `GpuTelemetry` do backend (document-comparison/core/inference). */
export interface GpuTelemetry {
  id: string;
  ready: boolean;
  temp_c?: number;
  util_pct?: number;
  mem_used_mb?: number;
  mem_total_mb?: number;
}

/** Fila de um modelo no gateway (contrato v3). */
export interface VelosterQueueStats {
  depth: number;
  backlog_s: number;
  oldest_wait_s: number | null;
  by_priority: Record<string, number>;
}

/** Espelha `VelosterHealthDto` do backend (GET /veloster/health). */
export interface VelosterHealthStatus {
  level: VelosterHealthLevel;
  gpus: GpuTelemetry[];
  counts: Record<string, number>;
  failureRate: number;
  checkedAt: string;
  /** Fila por modelo no gateway (ausente em gateway v2). */
  queue?: Record<string, VelosterQueueStats>;
  /** Modo da gpu1: `classificador-35b` (normal) ou `ft-invpl(replica)` (swap em rajada). */
  gpu1Mode?: string | null;
  /** `false` = Postgres da fila do gateway fora do ar (jobs só em memória). */
  queueDurable?: boolean | null;
}

export const velosterHealthService = {
  getStatus: (): Promise<VelosterHealthStatus> =>
    apiClient.get('/veloster/health').then((r) => r.data),
};
